angular.module("vgresiduos").controller("Conama313ReportCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "declaracoes/conama-313");
		};
	}
]);
